module.exports = __webpack_public_path__ + "img/example-cafeteria-menu-2-en.0342c49a.webp";